import ReactGA from "react-ga4";

export const initGA = () => {
    ReactGA.initialize("G-P6YES2PTRB");
  };

  export const trackPageView = (path) => {
    ReactGA.send({ hitType: "pageview", page: path });
  };